$(document).ready(function () {
    /**
    * TCR Module implementation
    */
    if (tcr_enable == true) {
        window['TCRHost'] = tcr_src;
        var tcr=document.createElement('script');
        tcr.src = tcr_src + 'assets/js/site.js';
        document.body.appendChild(tcr);

        let results = {};
        let value, key;
        let objectStructure = null;
        let index = 0;
        function createObj(obj, boxes) {
            key = obj.closest('.box').find('h2').data('title');
            // value = obj.text().replaceAll(" ", "_");
            value = obj.closest('li').find('input').val();
            if (objectStructure == null) {
                results[key] = value;

            } else if (boxes.hasClass('three')) {
                if (typeof results[key] === 'object') {
                    results[key][index++] = value;

                } else {
                    results[key] = {};
                    results[key][index++] = value;
                }
                objectStructure = results

            } else {
                results[key] = value;
            }

            objectStructure = results;
            // console.log(objectStructure);

            funnelEventEmitter('surveyResults', objectStructure);
        }
        
        $('label').on('click', function () {
            const boxes = $('.boxes');

            createObj($(this), boxes);
        })
    }


    /**
     * Queue popup with delay redirection
     */
    if(showQueueModal == true) {
        $('a[data-param]').click( function() {
            let path = $(this).attr('href');
            
            // console.log(path);
            
            setTimeout(function(){
                window.location.href = path;
            }, 500);
        })
    }

    /**
     * For mobile pagination
     */
    function pagination() {
        $('.nextStep').addClass('hidden');

        $('label').on('click', function () {
        // $('.answers__item').on('click', function () {
            const boxes = $('.boxes');
            const surveyForm = $('#surveyForm');

            if (surveyForm.hasClass('one')) {
                surveyForm.removeClass('one').addClass('two');

            } else if (surveyForm.hasClass('two')) {
                surveyForm.removeClass('two').addClass('three');
            }
        });

        $('.box.three label').on('click', function () {
        // $('.box.three .answers__item').on('click', function () {
            $('.nextStep').removeClass('hidden').addClass('show');
            $('.survey.three .box').addClass('clicked');
            $('.skip').addClass('clicked');
        })
    }

    if($('body').hasClass('surveyPage--v01')) {
        // console.log('surveyPage--v01');
        pagination();
    }

    //- Set current Year to footer Copyright
    if($('#year').length) {
        let thisDate = new Date();
        $('#year').html(thisDate.getFullYear());
    }
});
